function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_CUSTOMER = '/customer';
const ROOTS_SERVICES = '/services';
const ROOTS_MESSAGES = '/messages';
const ROOTS_JOB_BOARD = '/job-board';
const ROOTS_HOME = 'https://stintz.com/';
const ROOTS_PROVIDER = '/provider';
const ROOTS_BOOKINGS = '/bookings';
const ROOTS_QUOTES = '/quotes';
const ROOTS_EXTERNAL_REVIEWS = '/external-reviews';

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  landing: path(ROOTS_AUTH, '/landing'),
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  signUp: path(ROOTS_AUTH, '/sign-up'),
  checkEmail: path(ROOTS_AUTH, '/check-email'),
};

export const PATH_PAGE = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
};

export const PATH_CUSTOMER = {
  root: ROOTS_CUSTOMER,
  dashboard: path(ROOTS_CUSTOMER, '/dashboard'),
  profile: path(ROOTS_CUSTOMER, '/profile'),
  favourites: path(ROOTS_CUSTOMER, '/favourites'),
  reviews: path(ROOTS_CUSTOMER, '/reviews'),
  permissionDenied: path(ROOTS_CUSTOMER, '/permission-denied'),
  jobs: {
    root: path(ROOTS_CUSTOMER, '/jobs'),
    create: path(ROOTS_CUSTOMER, '/jobs/create'),
    edit: (id) => path(ROOTS_CUSTOMER, `/jobs/${id}/edit`),
  },
  bookings: {
    root: path(ROOTS_CUSTOMER, '/bookings'),
    details: (id) => path(ROOTS_CUSTOMER, `/bookings/${id}/details`),
    paymentComplete: (id) => path(ROOTS_CUSTOMER, `/bookings/${id}/payment-complete`),
  },
};

export const PATH_PROVIDER = {
  root: ROOTS_PROVIDER,
  dashboard: path(ROOTS_PROVIDER, '/dashboard'),
  bankingDetails: path(ROOTS_PROVIDER, '/banking-details'),
  profile: path(ROOTS_PROVIDER, '/profile'),
  previewProfile: path(ROOTS_PROVIDER, '/preview-profile'),
  manageSubscription: path(ROOTS_PROVIDER, '/manage-subscription'),
  subscriptionCallback: path(ROOTS_PROVIDER, '/subscription/callback'),
  details: (id) => path(ROOTS_PROVIDER, `/${id}/details`),
  reviews: path(ROOTS_PROVIDER, '/reviews'),
  listings: {
    root: path(ROOTS_PROVIDER, '/listings'),
    create: path(ROOTS_PROVIDER, '/listings/create'),
    edit: (id) => path(ROOTS_PROVIDER, `/listings/${id}/edit`),
    preview: path(ROOTS_PROVIDER, '/listings/preview'),
  },
  quotes: {
    root: path(ROOTS_PROVIDER, '/quotes'),
    create: path(ROOTS_PROVIDER, '/quotes/create'),
  },
  calendar: path(ROOTS_PROVIDER, '/calendar'),
  bookings: {
    root: path(ROOTS_PROVIDER, '/bookings'),
    details: (id) => path(ROOTS_PROVIDER, `/bookings/${id}/details`),
  },
};

export const PATH_SERVICES = {
  root: ROOTS_SERVICES,
  list: path(ROOTS_SERVICES, '/list'),
  details: (id) => path(ROOTS_SERVICES, `/${id}/details`),
};

export const PATH_MESSAGES = {
  root: ROOTS_MESSAGES,
  profile: path(ROOTS_MESSAGES, '/profile'),
};

export const PATH_QUOTES = {
  root: ROOTS_QUOTES,
  details: (id) => path(ROOTS_QUOTES, `/${id}/details`),
};

export const PATH_JOB_BOARD = {
  root: ROOTS_JOB_BOARD,
  details: (id) => path(ROOTS_JOB_BOARD, `/${id}/details`),
};

export const PATH_HOME = {
  root: ROOTS_HOME,
};

export const PATH_BOOKINGS = {
  root: ROOTS_BOOKINGS,
  details: (id) => path(ROOTS_BOOKINGS, `/${id}/details`),
};

export const PATH_EXTERNAL_REVIEWS = {
  root: ROOTS_EXTERNAL_REVIEWS,
  externalReview: (listingId) => path(ROOTS_EXTERNAL_REVIEWS, `/${listingId}`),
};
